import { Injectable } from '@angular/core'
import { Converter } from '@spartacus/core'
import { EbCmsStructureModel } from '../../interfaces/eb-page.interface'

@Injectable({ providedIn: 'root' })
export class EbCmsPageNormalizer implements Converter<any, EbCmsStructureModel> {
  convert(source: any, target: EbCmsStructureModel): EbCmsStructureModel {
    target.page.metaTitle = source?.metaTitle
    target.page.metaDescription = source?.metaDescription
    target.page.logo = source?.logo
    return target
  }
}
